export const countries = [
  'Andorre',
  'Émirats Arabes Unis',
  'Afghanistan',
  'Antigua-Et-Barbuda',
  'Anguilla',
  'Albanie',
  'Arménie',
  'Angola',
  'Région Asie/Pacifique',
  'Antarctique',
  'Argentine',
  'Samoa Américaines',
  'Autriche',
  'Australie',
  'Aruba',
  'Îles Åland',
  'Azerbaïdjan',
  'Bosnie-Herzégovine',
  'Barbad',
  'Bangladesh',
  'Belgique',
  'Burkina Faso',
  'Bulgarie',
  'Bahreïn',
  'Burundi',
  'Bénin',
  'Saint-Barthélemy',
  'Bermudes',
  'Brunei Darussalam',
  'État Plurinational De Bolivie',
  'Bonaire, Saint-Eustache Et Saba',
  'Brésil',
  'Bahamas',
  'Bhoutan',
  'Île Bouvet',
  'Botswana',
  'Biélorussie',
  'Belize',
  'Canada',
  'Îles Cocos',
  'République Démocratique Du Congo',
  'République Centrafricaine',
  'Congo',
  'Suisse',
  "Côte D'Ivoire",
  'Îles Cook',
  'Chili',
  'Cameroun',
  'Chine',
  'Colombie',
  'Costa Rica',
  'Cuba',
  'Cap-Vert',
  'Curaçao',
  'Île Christmas',
  'Chypre',
  'République Tchèque',
  'Allemagne',
  'Djibouti',
  'Denmark',
  'Dominique',
  'République Dominicaine',
  'Algérie',
  'Équateur',
  'Estonie',
  'Égypte',
  'Sahara Occidental',
  'Érythrée',
  'Espagne',
  'Éthiopie',
  'Europe',
  'Finlande',
  'Fidji',
  'Îles Malouines',
  'États Fédérés De Micronésie',
  'Îles Féroé',
  'France',
  'Gabon',
  'Royaume-Uni',
  'Grenade',
  'Géorgie',
  'Guyane',
  'Guernesey',
  'Ghana',
  'Gibraltar',
  'Groenland',
  'Gambie',
  'Guinée',
  'Guadeloupe',
  'Guinée Équatoriale',
  'Grèce',
  'Géorgie Du Sud-Et-Les Îles Sandwich Du Sud',
  'Guatemala',
  'Guam',
  'Guinée-Bissau',
  'Guyana',
  'Hong Kong',
  'Îles Heard-Et-MacDonald',
  'Honduras',
  'Croatie',
  'Haïti',
  'Hongrie',
  'Indonésie',
  'Irlande',
  'Île De Man',
  'Inde',
  "Territoire Britannique De L'océan Indien",
  'Irak',
  "République Islamique D'Iran",
  'Islande',
  'Italie',
  'Jersey',
  'Jamaïque',
  'Jordanie',
  'Japon',
  'Kenya',
  'Kirghizistan',
  'Cambodge',
  'Kiribati',
  'Comores',
  'Saint-Christophe-et-Niévès',
  'République Populaire Démocratique De Corée',
  'République De Corée',
  'Koweït',
  'Îles Caïmans',
  'Kazakhstan',
  'République Démocratique Populaire Lao',
  'Liban',
  'Sainte-Lucie',
  'Liechtenstein',
  'Sri Lanka',
  'Liberia',
  'Lesotho',
  'Lituanie',
  'Luxembourg',
  'Lettonie',
  'Libye',
  'Maroc',
  'Monaco',
  'République De Moldavie',
  'Monténégro',
  'Saint-Martin (Partie Française)',
  'Madagascar',
  'Îles Marshall',
  'Macédoine',
  'Mali',
  'Birmanie',
  'Mongolie',
  'Macao',
  'Îles Mariannes Du Nord',
  'Martinique',
  'Mauritanie',
  'Montserrat',
  'Malte',
  'Maurice',
  'Maldives',
  'Malawi',
  'Mexique',
  'Malaisie',
  'Mozambique',
  'Namibie',
  'Nouvelle-Calédonie',
  'Niger',
  'Île Norfolk',
  'Nigéria',
  'Nicaragua',
  'Pays-Bas',
  'Norvège',
  'Népal',
  'Nauru',
  'Niue',
  'Nouvelle-Zélande',
  'Oman',
  'Panama',
  'Pérou',
  'Polynésie Française',
  'Papouasie-Nouvelle-Guinée',
  'Philippines',
  'Pakistan',
  'Pologne',
  'Saint-Pierre-Et-Miquelon',
  'Pitcairn',
  'Porto Rico',
  'Palestine',
  'Portugal',
  'Palaos',
  'Paraguay',
  'Qatar',
  'Réunion',
  'Roumanie',
  'Serbie',
  'Fédération De Russie',
  'Rwanda',
  'Arabie Saoudite',
  'Îles Salomon',
  'Seychelles',
  'Soudan',
  'Suède',
  'Singapour',
  'Sainte-Hélène',
  'Slovénie',
  'Svalbard Et Jan Mayen',
  'Slovaquie',
  'Sierra Leone',
  'Saint-Marin',
  'Sénégal',
  'Somalie',
  'Suriname',
  'Soudan Du Sud',
  'Sao Tomé-Et-Principe',
  'République Du Salvador',
  'Saint-Martin (Partie Néerlandaise)',
  'République Arabe Syrienne',
  'Swaziland',
  'Îles Turks-Et-Caïcos',
  'Tchad',
  'Terres Australes Françaises',
  'Togo',
  'Thaïlande',
  'Tadjikistan',
  'Tokelau',
  'Timor-Leste',
  'Turkménistan',
  'Tunisie',
  'Tonga',
  'Turquie',
  'Trinité-Et-Tobago',
  'Tuvalu',
  'Taïwan',
  'République-Unie De Tanzanie',
  'Ukraine',
  'Ouganda',
  'Îles Mineures Éloignées Des États-Unis',
  'États-Unis',
  'Uruguay',
  'Ouzbékistan',
  'Saint-Siège (État De La Cité Du Vatican)',
  'Saint-Vincent-Et-Les Grenadines',
  'Venezuela',
  'Îles Vierges Britanniques',
  'Îles Vierges Des États-Unis',
  'Viet Nam',
  'Vanuatu',
  'Wallis Et Futuna',
  'Samoa',
  'Yémen',
  'Mayotte',
  'Afrique Du Sud',
  'Zambie',
  'Zimbabwe'
]
export const countryCodes = [
  'AC',
  'AD',
  'AE',
  'AF',
  'AG',
  'AI',
  'AL',
  'AM',
  'AO',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'AX',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BL',
  'BM',
  'BN',
  'BO',
  'BQ',
  'BR',
  'BS',
  'BT',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CC',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CK',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CU',
  'CV',
  'CW',
  'CX',
  'CY',
  'CZ',
  'DE',
  'DJ',
  'DK',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'EH',
  'ER',
  'ES',
  'ET',
  'FI',
  'FJ',
  'FK',
  'FM',
  'FO',
  'FR',
  'GA',
  'GB',
  'GD',
  'GE',
  'GF',
  'GG',
  'GH',
  'GI',
  'GL',
  'GM',
  'GN',
  'GP',
  'GQ',
  'GR',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'HN',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IM',
  'IN',
  'IO',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JE',
  'JM',
  'JO',
  'JP',
  'KE',
  'KG',
  'KH',
  'KI',
  'KM',
  'KN',
  'KP',
  'KR',
  'KW',
  'KY',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MF',
  'MG',
  'MH',
  'MK',
  'ML',
  'MM',
  'MN',
  'MO',
  'MP',
  'MQ',
  'MR',
  'MS',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NC',
  'NE',
  'NF',
  'NG',
  'NI',
  'NL',
  'NO',
  'NP',
  'NR',
  'NU',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PF',
  'PG',
  'PH',
  'PK',
  'PL',
  'PM',
  'PR',
  'PS',
  'PT',
  'PW',
  'PY',
  'QA',
  'RE',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SB',
  'SC',
  'SD',
  'SE',
  'SG',
  'SH',
  'SI',
  'SJ',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'SS',
  'ST',
  'SV',
  'SX',
  'SY',
  'SZ',
  'TA',
  'TC',
  'TD',
  'TG',
  'TH',
  'TJ',
  'TK',
  'TL',
  'TM',
  'TN',
  'TO',
  'TR',
  'TT',
  'TV',
  'TW',
  'TZ',
  'UA',
  'UG',
  'US',
  'UY',
  'UZ',
  'VA',
  'VC',
  'VE',
  'VG',
  'VI',
  'VN',
  'VU',
  'WF',
  'WS',
  'XK',
  'YE',
  'YT',
  'ZA',
  'ZM',
  'ZW'
] as const
